module.exports = __webpack_public_path__ + "static/media/login-background@2x.f1ceef14.jpg";